import { cxmService } from '@/services/cxm.service';

const TIENDANUBE_APP_ID = import.meta.env.VITE_APP_TIENDANUBE_APP_ID;

export function getTiendanubeMarketplaceAuthorizationUrl(): string {
  return `https://www.tiendanube.com/apps/${TIENDANUBE_APP_ID}/authorize`;
}

export async function getAuthenticatedTiendanubeAuthorizationUrl(): Promise<string> {
  const { data: response } = await cxmService.createTiendanubeAuthorizationState();
  const state = response?.data?.state;

  if (typeof state !== 'string' || state.length === 0) {
    throw new Error('CXM did not create a Tiendanube authorization state. Please try again.');
  }

  const authorizationUrl = new URL(getTiendanubeMarketplaceAuthorizationUrl());
  authorizationUrl.searchParams.set('state', state);

  return authorizationUrl.toString();
}

export async function openAuthenticatedTiendanubeAuthorization(
  target: '_self' | '_blank' = '_self',
): Promise<void> {
  const authorizationWindow = target === '_blank' ? window.open('about:blank', target) : null;

  try {
    const authorizationUrl = await getAuthenticatedTiendanubeAuthorizationUrl();

    if (authorizationWindow) {
      authorizationWindow.location.replace(authorizationUrl);
    } else {
      window.location.assign(authorizationUrl);
    }
  } catch (error) {
    authorizationWindow?.close();
    throw error;
  }
}
